"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_apexcharts_1 = __importDefault(require("react-apexcharts"));
const common_1 = require("@components/common");
const _params_1 = require("@params");
const js_cookie_1 = __importDefault(require("js-cookie"));
const dateUtils_1 = require("@app/utils/dateUtils");
const locale_1 = __importDefault(require("../locale"));
const CategoryHalfDonutsPopup_1 = __importDefault(require("@app/routes/Dashboard/components/CategoryHalfDonutsPopup"));
const useChartCustomTooltip_1 = require("@app/routes/Dashboard/hooks/useChartCustomTooltip");
const useTargetExerciseContext_1 = require("@app/routes/Dashboard/hooks/useTargetExerciseContext");
const ChartSelect_1 = require("@components/form/ChartSelect");
const useChartsDateFilterContext_1 = require("@app/routes/Dashboard/hooks/useChartsDateFilterContext");
const CategoryColumns = () => {
    var _a;
    const [categoryKey, setCategoryKey] = (0, react_1.useState)('articulation');
    const [columnsInfo, setColumnsInfo] = (0, react_1.useState)();
    const { setTargetExercise } = (0, useTargetExerciseContext_1.useTargetExerciseContext)();
    const { openTooltip, closeTooltip, tooltipState } = (0, useChartCustomTooltip_1.useChartCustomTooltip)({ initState: {} });
    const { filterState } = (0, useChartsDateFilterContext_1.useChartsDateFilterContext)();
    (0, react_1.useEffect)(() => {
        fetch(_params_1.apiHost
            // @ts-ignore
            + `/charts/count_categories?group=${categoryKey}&by_day=true&date_start=${filterState.fromDate}&date_end=${filterState.toDate}&user=${userId}`, {
            method: "GET",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
                "X-CSRFToken": js_cookie_1.default.get("csrftoken")
            }
        }).then(response => response.json()).then(response => setColumnsInfo(response));
    }, [categoryKey, filterState.fromDate, filterState.toDate]);
    const getDataPercent = value => value ? Number(value).toFixed(2) : null;
    if (!columnsInfo)
        return null;
    const columnsToDisplayCount = 9;
    // @ts-ignore
    const itemsLength = Object.keys(columnsInfo).length;
    const startIndex = itemsLength ? itemsLength - columnsToDisplayCount : 0;
    // @ts-ignore
    const visibleData = Object.values(columnsInfo); //.slice(startIndex, itemsLength);
    const visibleDataKeys = Object.keys(columnsInfo); //.slice(startIndex, itemsLength);
    const periodData = visibleData.reduce((acc, e) => {
        var _a, _b, _c, _d;
        acc.red.push(getDataPercent((_a = e === null || e === void 0 ? void 0 : e.many_mistakes) === null || _a === void 0 ? void 0 : _a.percent));
        acc.yellow.push(getDataPercent((_b = e === null || e === void 0 ? void 0 : e.nice_try) === null || _b === void 0 ? void 0 : _b.percent));
        acc.blue.push(getDataPercent((_c = e === null || e === void 0 ? void 0 : e.good) === null || _c === void 0 ? void 0 : _c.percent));
        acc.green.push(getDataPercent((_d = e === null || e === void 0 ? void 0 : e.super) === null || _d === void 0 ? void 0 : _d.percent));
        return acc;
    }, {
        red: [],
        yellow: [],
        blue: [],
        green: []
    });
    const seriesKeys = ['many_mistakes', 'nice_try', 'good', 'super'];
    const buildTargetsParamsString = ({ dataPointIndex }) => 
    // @ts-ignore
    visibleData[dataPointIndex].target_values_info
        .map(e => `\n\r${e.target_key} ${Number(e.value * 100).toFixed(0)}%`).join('; ');
    const periodState = {
        series: [
            {
                name: locale_1.default.averageParameter,
                type: 'line',
                data: visibleData.map(e => e.target ? Number(e.target).toFixed(2) : 100)
            },
            {
                name: locale_1.default.many_mistakes,
                type: 'column',
                data: periodData === null || periodData === void 0 ? void 0 : periodData.red,
                color: '#FF564D',
                stacked: true,
            }, {
                name: locale_1.default.nice_try,
                type: 'column',
                color: '#FFC54D',
                data: periodData === null || periodData === void 0 ? void 0 : periodData.yellow,
                stacked: true,
            }, {
                name: locale_1.default.good,
                type: 'column',
                color: '#3BA1AA',
                data: periodData === null || periodData === void 0 ? void 0 : periodData.blue,
                stacked: true,
            }, {
                name: locale_1.default.super,
                type: 'column',
                color: '#3CB949',
                data: periodData === null || periodData === void 0 ? void 0 : periodData.green
            }
        ],
        options: {
            stroke: {
                show: true,
                width: 2
            },
            markers: {
                size: 5,
                strokeColors: '#413799',
                strokeWidth: 2,
                colors: ['#fff'],
                width: 10
            },
            responsive: [
                {
                    breakpoint: 779,
                    options: {
                        chart: {
                            width: 760
                        }
                    }
                },
                {
                    breakpoint: 400,
                    options: {
                        chart: {
                            width: 350
                        }
                    }
                }
            ],
            tooltip: {
                enabled: false,
                y: {
                    title: {
                        formatter: (seriesName) => seriesName
                    },
                    //formatter: (val: number, opts: any) => opts?.seriesIndex === 0 ? val.toString() : null
                    formatter: (val, { dataPointIndex, seriesIndex }) => {
                        const value = val + '%';
                        if (seriesIndex === 0)
                            return value + `: ${buildTargetsParamsString({ dataPointIndex })}`;
                        return value;
                    }
                }
            },
            chart: {
                toolbar: {
                    show: false,
                    tools: {
                        zoom: false
                    }
                },
                stacked: true,
                events: {
                    dataPointSelection: (e, chart, options) => {
                        var _a, _b, _c;
                        const { dataPointIndex, seriesIndex } = options;
                        console.log(options);
                        const { clientX, clientY } = ((_c = (_b = (_a = chart === null || chart === void 0 ? void 0 : chart.series) === null || _a === void 0 ? void 0 : _a.ctx) === null || _b === void 0 ? void 0 : _b.events.w) === null || _c === void 0 ? void 0 : _c.globals) || {};
                        openTooltip({
                            params: {
                                clientX,
                                clientY,
                                dataPointIndex,
                                seriesIndex
                            }
                        });
                    }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '45%',
                    endingShape: 'rounded',
                    borderRadius: 2
                },
            },
            legend: {
                floating: true,
                offsetY: -180,
                fontSize: '10px',
                markers: {
                    width: 8,
                    height: 8
                }
            },
            labels: visibleDataKeys.map(e => (0, dateUtils_1.toDayMonth)(e))
        }
    };
    const tooltipData = (_a = visibleData[tooltipState === null || tooltipState === void 0 ? void 0 : tooltipState.dataPointIndex]) === null || _a === void 0 ? void 0 : _a[seriesKeys === null || seriesKeys === void 0 ? void 0 : seriesKeys[(tooltipState === null || tooltipState === void 0 ? void 0 : tooltipState.seriesIndex) - 1]];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(common_1.Plate, { padding: "20px 0 0 0", style: { position: 'relative' }, className: 'plate-chart' },
            react_1.default.createElement(ChartSelect_1.ChartSelect, { options: [
                    { name: locale_1.default.articulationTitle, value: 'articulation' },
                    { name: locale_1.default.soundTitle, value: 'sound' },
                    { name: locale_1.default.motorTitle, value: 'motor' }
                ], onChange: ev => setCategoryKey(ev.target.value), value: categoryKey, style: {} }),
            react_1.default.createElement(react_apexcharts_1.default, { options: periodState.options, series: periodState.series, type: "line", width: "780px", height: "200px" })),
        tooltipState.show && tooltipData && (react_1.default.createElement(CategoryHalfDonutsPopup_1.default, { ev: tooltipState, data: {
                [tooltipState.dataPointIndex]: tooltipData
            }, closePopup: closeTooltip, setTargetExercise: setTargetExercise }))));
};
exports.default = CategoryColumns;
